var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{style:({ backgroundImage: `url(${require('@/' + _vm.backgroundImagePath)})` }),attrs:{"id":"content_public_index"}},[_vm._v(" contact us ")])
}
var staticRenderFns = []

export { render, staticRenderFns }